import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import AppProviders from './AppProviders'

ReactDOM.render(
  <React.StrictMode>
    <AppProviders />
  </React.StrictMode>,
  document.getElementById('root')
)
